/** Imports ---------------------------------------------------------------- */

/** React imports */
import React from "react";
import { useTranslation } from "react-i18next";

/** Icons */
import { ReactComponent as InfoIcon } from "../../../assets/images/info-icon.svg";

/** MUI imports */
import { styled } from "@mui/material/styles";
import { Button, Dialog, DialogActions, DialogContent, Slide, Typography } from "@mui/material";

const PREFIX = "DialogAlertsCustom";

const classes = {
    icon: `${PREFIX}-icon`,
};

const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: "32px 32px 8px",
    },
    "& .MuiDialogTitle-root": {
        backgroundColor: "#031851",
        fontSize: "18px",
        color: "#fff",
    },
    "& .MuiDialog-paper": {
        borderRadius: 8,
        boxShadow: "10px 10px 15px rgba(3,24,81,0.15)",
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(2),
    },

    [`& .${classes.icon}`]: {
        height: 120,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogAlertsCustom = (props) => {
    /** Internationalization i18n */
    const [t] = useTranslation("global");

    return (
        <CustomDialog
            open={props.open}
            onClose={props.onClose}
            maxWidth="sm"
            fullWidth={true}
            TransitionComponent={Transition}
        >
            <DialogContent>
                <InfoIcon fill="#3FC3EE" className={classes.icon} />
                <Typography variant="h1" color="primary" align="center" sx={{ fontSize: 24, pt: 1 }}>
                    {t("miscellaneous.registeredChangesGroup2")}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ ml: "auto", mr: "auto" }}>
                <Button
                    disableElevation
                    variant="outlined"
                    color="secondary"
                    onClick={props.agreeAllAction}
                    sx={{
                        border: "1px solid #ff5968",
                        borderRadius: 40,
                        fontSize: 18,
                        "&:hover": {
                            border: "1px solid #2f3190",
                            color: "#2f3190",
                        },
                    }}
                >
                    {t("miscellaneous.all")}
                </Button>
                <Button
                    disableElevation
                    variant="contained"
                    color="secondary"
                    onClick={props.agreeOnlyActive}
                    sx={{
                        borderRadius: 40,
                        fontSize: 18,
                        ml: "24px !important",
                        "&:hover": {
                            backgroundColor: "#2f3190",
                            color: "#fff",
                        },
                    }}
                >
                    {t("miscellaneous.onlyActives")}
                </Button>
            </DialogActions>
        </CustomDialog>
    );
};

export default DialogAlertsCustom;
